import React, { } from "react";
import AppRoutes from "./AppRoutes";
// import { ErrorBoundary } from "app/ErrorBoundary";
// import { SnackbarProvider } from "notistack";

// import "pages/EMDR/emdr.css";
import "pages/EMDR/emdr.scss";
// import ToastContainer from "react-toastify";

// import "https://cdn.onesignal.com/sdks/OneSignalSDKWorker.js";

export default function App() {
  return (
    // <SnackbarProvider
    //   anchorOrigin={{
    //     vertical: "top",
    //     horizontal: "center",
    //   }}
    //   maxSnack={3}
    // >
    <div>
      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
      <AppRoutes />
    </div>

    // </SnackbarProvider>
  );
}
